<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
            <tt-button-goto *ngIf="functionName === 'product'" ttText="productsearch_new_product" ttGoto="productcreate" [ttGotoParms]="{ argtype: '-', argvalue: '-' }" ttIcon="far fa-plus"></tt-button-goto>
            <ng-container *ngTemplateOutlet="buttonGroups"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListProducts"></tt-list>

        <tt-card *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                <ng-container *ngTemplateOutlet="buttonGroups"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5" *ngIf="functionName === 'product' || setting.show_setting === '1'">
                <tt-button-goto *ngIf="functionName === 'product'" ttText="productsearch_new_product" ttGoto="productcreate" [ttGotoParms]="{ argtype: '-', argvalue: '-' }" ttIcon="far fa-plus"></tt-button-goto>
                <tt-button-settings *ngIf="setting.show_setting === '1'"></tt-button-settings>
            </tt-card>
        </div>

        <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!setting">
        <tt-select [hidden]="selectListCompanies.length === 1" ttRememberId="stock.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select [hidden]="selectListCompanies.length === 1 || ( selectListCompanies.length === 1 && selectListStockPlaces.length > 1)" ttRememberId="stock.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>

        <form class="form-horizontal sp-0" name="formProductSearchText" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttLabel="productsearch_searchtext" ttFocus [(ttModel)]="setting.productsearch_searchtext" [ttButtons]="productSearchTextButtons"></tt-input>
        </form>
    </ng-container>
</ng-template>

<ng-template #buttonGroups>
    <ng-container>
        <tt-tabs *ngIf="functionName === 'choice'" [(ttSelectedId)]="selectedBgPickType" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="product" ttLabel="product"></tt-tab>
            <tt-tab ttId="stock" ttLabel="stock"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <div ng-show="vm.model.selectListCompanies.length > 1">
            <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        </div>

        <div ng-show="vm.model.selectListCompanies.length > 1 || ( vm.model.selectListCompanies.length === 1 && vm.model.selectListStockPlaces.length > 1)">
            <tt-select class="col-xs-12 sp-0" tt-label="stockplace" tt-model="vm.model.setting.stockplace_id" tt-change="vm.onChanged($value, 'stockplace_id')" tt-data="vm.model.selectListStockPlaces" tt-data-id="stockplace_id" tt-data-name="stockplace_name"></tt-select>
        </div>

        <form class="form-horizontal im-no-pad" name="formProductSearchText" ng-submit="vm.searchItems()" novalidate method="get" role="form">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="productsearch_searchtext" tt-model="vm.model.setting.productsearch_searchtext" tt-change="vm.onChanged($value, 'productsearch_searchtext')" tt-placeholder="" tt-buttons="vm.model.productSearchTextButtons" tt-readonly="false"></tt-input-buttons>
        </form>

        <div ng-if="vm.model.functionName === 'product'">
            <tt-button class="col-xs-12 sp-0" tt-text="productsearch_new_product" tt-click="vm.goToFunc('productcreate')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
        </div>

        <div ng-if="vm.model.functionName === 'choice'">
            <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgPickType.buttons" tt-model="vm.model.bgPickType.selected" tt-change="vm.selectBgPickType($value)"></tt-buttons-radio>
        </div>
    </tt-card>

    <im-list-directive class="col-xs-12 sp-0" list-items="vm.model.itemsListProducts" badge="" ltype="" design-var="s12t0"></im-list-directive>

    <tt-card class="col-xs-12 sp-0" ng-if="vm.model.setting.show_setting === '1'">
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page>

<tt-page class="col-xs-12 sp-0 height-full" ng-if="vm.model.tabletSize.matches === true">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <div ng-show="vm.model.selectListCompanies.length > 1">
                <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.setting.businessco_no" tt-change="vm.onChanged($value, 'businessco_no')" tt-data="vm.model.selectListCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
            </div>

            <div ng-show="vm.model.selectListCompanies.length > 1 || ( vm.model.selectListCompanies.length === 1 && vm.model.selectListStockPlaces.length > 1)">
                <tt-select class="col-xs-12 sp-0" tt-label="stockplace" tt-model="vm.model.setting.stockplace_id" tt-change="vm.onChanged($value, 'stockplace_id')" tt-data="vm.model.selectListStockPlaces" tt-data-id="stockplace_id" tt-data-name="stockplace_name"></tt-select>
            </div>

            <form class="form-horizontal im-no-pad" name="formProductSearchText" ng-submit="vm.searchItems()" novalidate method="get" role="form">
                <tt-input-buttons class="col-xs-12 sp-0" tt-label="productsearch_searchtext" tt-model="vm.model.setting.productsearch_searchtext" tt-change="vm.onChanged($value, 'productsearch_searchtext')" tt-placeholder="" tt-buttons="vm.model.productSearchTextButtons" tt-readonly="false"></tt-input-buttons>
            </form>

            <div ng-if="vm.model.functionName === 'choice'">
                <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgPickType.buttons" tt-model="vm.model.bgPickType.selected" tt-change="vm.selectBgPickType($value)"></tt-buttons-radio>
            </div>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ng-if="vm.model.functionName === 'product' || vm.model.setting.show_setting === '1'">
            <div ng-if="vm.model.functionName === 'product'">
                <tt-button class="col-xs-12 sp-0" tt-text="productsearch_new_product" tt-click="vm.goToFunc('productcreate')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
            </div>

            <div ng-if="vm.model.setting.show_setting === '1'">
                <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
            </div>
        </tt-card>
    </div>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
